import { Text, Layout } from '@loadsmart/miranda-react'

import { Item } from '../../ui/components/item/Item'
import { type ContainerDirection } from '../domain/ShipmentContainer'
import { formatDrayageShipmentDirection } from '../presenters/ContainerPresenter'

type DrayageLoadDirectionProps = {
  domain: 'rate' | 'tender' | 'shipment'
  direction?: ContainerDirection
}

export function DrayageLoadDirection({ domain, direction }: DrayageLoadDirectionProps) {
  if (domain === 'rate') {
    return (
      <Layout.Stack gap="spacing-0-5">
        <Text variant="body-md-bold" color="color-text-primary">
          Direction
        </Text>
        <Text variant="body-md">{formatDrayageShipmentDirection(direction)}</Text>
      </Layout.Stack>
    )
  }
  return (
    <Item
      label="Direction"
      value={<Text variant="body-md">{formatDrayageShipmentDirection(direction)}</Text>}
    />
  )
}
